export default __webpack_public_path__ + "3a285bc34de6e434f5a44bd4464a50f8.png";